/**
 * Tokens de cor da claquete.
 * @react-pdf/renderer não suporta variáveis CSS — valores definidos aqui
 * para facilitar manutenção e rastreabilidade.
 */
export const CLAPPERBOARD_COLORS = <const>{
  text: "#18181C",
  cellBackground: "#f0f0f0",
  white: "#FFFFFF",
};
